import { AcceptTerms } from './acceptTerms';

require('./acceptTerms.scss');

export const myAcceptTermsComponent = {
  template: require('./acceptTerms.html'),
  controllerAs: 'ctrl',
  controller: AcceptTerms,
};
